import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { PdpGalleryDialogComponent } from './pdp-gallery-dialog.component'
import { PdpGalleryCarouselModule } from '../pdp-gallery-carousel/pdp-gallery-carousel.module'
import { CmsDirectivesModule } from '../../../cms/directives/cms-directives.module'

@NgModule({
  declarations: [PdpGalleryDialogComponent],
    imports: [
        CommonModule,
        NgbModule,
        MbI18nModule,
        PdpGalleryCarouselModule,
        CmsDirectivesModule
    ]
})
export class PdpGalleryDialogModule { }
